module.exports = __webpack_public_path__ + "images/classroom.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/classroom.jpg
 ** module id = 51
 ** module chunks = 1
 **/